import { Component, OnInit, ChangeDetectionStrategy, ViewChild, ElementRef } from '@angular/core';

import { SidebarComponent } from '../sidebar/sidebar.component';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'artemis-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent implements OnInit {

  @ViewChild(SidebarComponent, {static: false}) sidebarComponent: SidebarComponent;
  @ViewChild('content', {static: false}) content: ElementRef;
  constructor(private router: Router) { }

  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      this.content.nativeElement.scrollTop = 0;
    });
  }

  /**
   * Handles when user triggers sidebar from header
   * @method headerToggleSidebarHandler
   */
  headerToggleSidebarHandler($event: boolean): void {
    this.sidebarComponent.toggleSidebar();
  }

}
